import PropTypes from 'prop-types';
import React from 'react';
import formatRupees from '../../utils/currency';

function DataCard({
  icon, title, value, className, borderColor,
}) {
  return (
    <div className={` flex md:flex-row flex-col items-center justify-start gap-6 border border-[1px] border-[#B8E5FF] rounded-[6px] px-3 py-3 md:px-7 md:py-7 bg-white ${className} border-b-[4px] border-b-[${borderColor}]`}>
      <div className="bg-[#E3F5FF] rounded-full p-4">
        {icon}
      </div>
      <div className="flex flex-col  gap-4 leading-none">
        <h2 className="md:text-[20px] text-[16px] font-semibold">{title}</h2>
        <h2 className="md:text-[20px] text-[16px] md:text-left text-center font-normal">
          {formatRupees(value)}
        </h2>
      </div>
    </div>
  );
}

export default DataCard;

// type validation
DataCard.propTypes = {
  icon: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.elementType,
  ]),
  title: PropTypes.string,
  value: PropTypes.string,
  className: PropTypes.string,
  borderColor: PropTypes.string,
};
